"use client";
"use client";
import { ANIMATION_GLOBAL_OFFSET } from "@/lib/animationConfig";
import { useEffect, useRef, useState } from "react";

export default function AnimatedCarousel({ children, className = "", ...props }) {
	const ref = useRef(null);
	const [inView, setInView] = useState(false);

	useEffect(() => {
		const observer = new IntersectionObserver(
			([entry]) => {
				if (!document.body.classList.contains("page-enter")) {
					setInView(entry.isIntersecting);
				}
			},
			{
				threshold: 0,
				rootMargin: "0% 0% -15% 0%",
			}
		);

		const mutation = new MutationObserver(() => {
			if (!document.body.classList.contains("page-enter") && ref.current) {
				observer.observe(ref.current);
			}
		});

		mutation.observe(document.body, { attributes: true, attributeFilter: ["class"] });

		return () => {
			observer.disconnect();
			mutation.disconnect();
		};
	}, []);

	return (
		<div
			ref={ref}
			className={`animated-carousel ${inView ? "inview" : ""} ${className}`}
			style={inView ? { animationDelay: `${ANIMATION_GLOBAL_OFFSET}s` } : {}}
			{...props}
		>
			{children}
		</div>
	);
}